import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit, Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {CaptureService} from '../../services/capture-service';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {adaptToAPI, MY_DATE_FORMATS} from '../../utils/formHepler';
import {Invoice} from '../../model/invoice';
import {Party} from '../../model/party';
import {InvoiceService} from '../../services/invoice.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {amountsCleaner, iceCleaner, referenceCleaner} from '../../utils/cleaners';
import {amountsParser, dateParser} from '../../utils/parsers';
import {catchError, debounceTime, takeUntil} from 'rxjs/operators';
import {Observable, of, Subject, Subscription} from 'rxjs';
import {NgModel} from '@angular/forms';
import {MatRadioChange} from '@angular/material/radio';
import {MatButtonToggleChange} from '@angular/material/button-toggle';
import {CurrencyService, ICurrency} from '../../services/currency.service';
import {WorkspacesService} from '../../services/workspaces.service';
import { MatSelect } from '@angular/material/select';

export interface IOption {
  id?: string;
  name?: string;
}

@Component({
  selector: 'app-capture-form',
  templateUrl: './capture-form.component.html',
  styleUrls: ['./capture-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter},
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {useStrict: true},
    },
  ],
  encapsulation: ViewEncapsulation.None
})
export class CaptureFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() focusedElement: string;
  @ViewChild('name') nameRef: ElementRef;
  @ViewChild('form') form: any;
  @ViewChild('iceRecipient') iceRecipient: NgModel;
  @ViewChild('iceSender') iceSender: NgModel;
  @ViewChildren('name, recipientPartyLegalId, invoiceNumber, orderReference, issueDateRef, taxExclusiveAmount, taxAmount, payableAmount, senderPartyName, senderPartyLegalId, payeeFinancialAccount') formInputs: QueryList<ElementRef>;
  @ViewChild('currencySelect', { read: MatSelect }) currencySelect: MatSelect;

  @Input() totalPages = 1;
  @Input() selectedPageForOcr = 1;
  @Input() pdfPageNumbers: number[] = [];
  @Input() ocrInProgress = false;
  @Input() availablePages: number[] = [1];

  @Output() pageSelected = new EventEmitter<number>();
  @Output() ocrRequested = new EventEmitter<void>();


  fields = new Map();
  invoice: Invoice;
  currentIndex: number;
  public taskId: string;
  invoiceId: string;
  modelId: string;
  legalId: string;
  currencies: IOption[];
  dateInFuture: boolean;
  today = new Date();
  canvas = true;
  currentPage = '1';
  isPdf: boolean;
  private formId: string;
  private workspaceId: any;
  private invoiceTaskSubscription: Subscription;
  private routeParamSubscription: Subscription;
  private routeDateSubscription: Subscription;
  private subjectSelectionSubscription: Subscription;
  private iceSupplierCountSubscription: Subscription;
  private readonly destroy$ = new Subject();
  private submittingForm = false;
  shouldSuppressMatSelectEnter = false;

  // availablePages: number[] = [1]; // Start with page 1
  // totalPdfPages = 1;
  // private availablePagesSubscription: Subscription;
  // private totalPagesSubscription: Subscription;

  constructor(
    private captureService: CaptureService,
    private invoiceService: InvoiceService,
    private currencyService: CurrencyService,
    private workspaceService: WorkspacesService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.submittingForm = false;
    this.routeParamSubscription = this.route.params.subscribe(
      (params: Params) => (this.taskId = params.id)
    );
    this.routeDateSubscription = this.route.data.subscribe((data) => {
      this.formId = data.formMetadata.id;
    });

    this.initInvoice();
    this.initializeFields();
    // set the current index to the first field
    this.currentIndex = 0;
    this.captureService.changeInput(this.fields.get(0).text);

    this.captureService.isPdfSubject.subscribe((value) => (this.isPdf = value));

    // Subscribe to canvas toggle changes
    this.captureService.canvasChosen.subscribe((isCanvas) => {
      this.canvas = isCanvas;
      this.cdr.detectChanges();
    });

    // this.availablePagesSubscription = this.captureService.availablePages$.subscribe(
    //   (pages) => {
    //     this.availablePages = this.sortPages(pages);
    //     this.cdr.detectChanges();
    //   }
    // );

    // this.totalPagesSubscription = this.captureService.totalPdfPages$.subscribe(
    //   (total) => {
    //     this.totalPdfPages = total;
    //   }
    // );

    this.captureService.pageChanged.subscribe((page) => {
      this.currentPage = page;
      this.cdr.detectChanges();
    });

    // this.captureService.canvasClicked.subscribe(() => { this.focusCurrentInput(); })
  }

  onPageSelectedForOcr(value: number) {
    this.pageSelected.emit(value);
  }

  isPageAlreadyOcred(pageNumber: number): boolean {
    if (pageNumber === 1) { return true; }
    if (pageNumber === this.totalPages) {
      return this.availablePages.includes(pageNumber) || this.availablePages.includes(-1);
    }
    return this.availablePages.includes(pageNumber);
  }

  requestOcr() {
    this.ocrRequested.emit();
  }

  private sortPages(pages: number[]): number[] {
    const sorted = [...pages].sort((a, b) => {
      // Handle -1 (last_page) - always put it at the end
      if (a === -1) { return 1; }
      if (b === -1) { return -1; }
      return a - b;
    });
    return sorted;
  }

  getPageValue(page: number): string {
    if (page === -1) {
      return 'last_page';
    }
    return page.toString();
  }

  getPageLabel(page: number): string {
    if (page === 1) {
      return 'First';
    }
    if (page === -1) {
      return 'Last';
    }
    return `${page}`;
  }

  /**
   * initialize the invoice object used in the form
   */
  initInvoice() {
    this.invoice = new Invoice();
    this.invoice.recipient_party = new Party();
    this.invoice.sender_party = new Party();
  }

  ngAfterViewInit(): void {
    // give focus to the first field
    this.nameRef.nativeElement.focus();

    this.invoiceTaskSubscription = this.captureService.task$.subscribe(
      (data) => {
        if (data) {
          this.handleResponseTask(data);
        }
      }
    );
    this.cdr.detectChanges();
  }

  /**
   * initialize each field of the form by it's index, name, label and type
   */
  initializeFields() {
    this.fields.set(
      0,
      new Field('recipientPartyName', 'Nom Destinataire', FormItemType.Text, '')
    );
    this.fields.set(
      1,
      new Field(
        'recipientPartyLegalId',
        'ICE Destinataire',
        FormItemType.Ice,
        ''
      )
    );
    this.fields.set(
      2,
      new Field('invoiceNumber', 'N° de Facture', FormItemType.Reference, '')
    );
    this.fields.set(
      3,
      new Field(
        'orderReference',
        'Référence Commande',
        FormItemType.Reference,
        ''
      )
    );
    this.fields.set(
      4,
      new Field('issueDate', 'Date Facture', FormItemType.Date, '')
    );
    this.fields.set(
      5,
      new Field('taxExclusiveAmount', 'Total HT', FormItemType.Number, '')
    );
    this.fields.set(
      6,
      new Field('taxAmount', 'Total Taxes', FormItemType.Number, '')
    );
    this.fields.set(
      7,
      new Field('payableAmount', 'Net à Payer', FormItemType.Number, '')
    );
    this.fields.set(
      8,
      new Field('senderPartyName', 'Nom Emetteur', FormItemType.Text, '')
    );
    this.fields.set(
      9,
      new Field('senderPartyLegalId', 'ICE Emetteur', FormItemType.Ice, '')
    );
    this.fields.set(
      10,
      new Field('payeeFinancialAccount', 'RIB Emetteur', FormItemType.Text, '')
    );
    this.fields.set(
      11,
      new Field('documentCurrencyCode', 'Devise', FormItemType.Text, '')
    );
  }

  @HostListener('document:keydown', ['$event'])
  handleGlobalKeyDown(event: KeyboardEvent) {
    if ((event.key === 'Enter' || event.key === 'Tab') && !event.shiftKey) {
      this.navigateFormElements(event, 'next');
    }

    if ((event.key === 'Enter' || event.key === 'Tab') && event.shiftKey) {
      this.navigateFormElements(event, 'previous');
    }
  }


  @HostListener('window:unload', ['$event'])
  unloadHandler(event: any) {
    this.unclaimTask(this.taskId).subscribe(() => {
      this.captureService.unclaimTask('');
    });
  }

  onSubmit() {
    this.submittingForm = true;
    this.invoiceService
      .submitInvoiceForm(
        this.captureService.currentTenantIdentifier,
        this.invoiceId,
        this.taskId,
        adaptToAPI(this.invoice),
        this.formId,
        'Enregistrer'
      )
      .subscribe(
        () => {
          // get the next task
          this.invoiceService
            .getTaskListFromAPI(
              null,
              this.captureService.selectedTenantIdentifier,
              'asc',
              0,
              1
            )
            .pipe(catchError(() => of([])))
            .subscribe((invoices) => {
              if (invoices.total < 1) {
                this.router.navigate(['capture']);
              } else {
                const invoice = invoices.data[0];
                this.initInvoice();
                this.currentIndex = 0;
                this.captureService.changeInput(
                  this.fields.get(this.currentIndex).text
                );
                this.router.navigate(['capture', invoice.id]);
              }
            });
        },
        () => {
        }
      );
  }

  /**
   * notify the viewer component the modification of the selected field
   */
  onFocus(index: number) {
    this.currentIndex = index;
    this.captureService.changeInput(this.fields.get(this.currentIndex).text);
  }

  isFormItemDate(formItem: Field): boolean {
    return formItem.type ? formItem.type === FormItemType.Date : false;
  }

  isFormItemNumber(formItem: Field): boolean {
    return formItem.type ? formItem.type === FormItemType.Number : false;
  }

  isFormItemReference(formItem: Field): boolean {
    return formItem.type ? formItem.type === FormItemType.Reference : false;
  }

  isFormItemIce(formItem: Field): boolean {
    return formItem.type ? formItem.type === FormItemType.Ice : false;
  }

  ngOnDestroy(): void {
    if (!this.submittingForm) {
      this.unclaimTask(this.taskId).subscribe(() => {
        this.captureService.unclaimTask('');
      });
    }

    if (this.invoiceTaskSubscription) {
      this.invoiceTaskSubscription.unsubscribe();
    }

    if (this.iceSupplierCountSubscription) {
      this.iceSupplierCountSubscription.unsubscribe();
    }
    this.subjectSelectionSubscription.unsubscribe();

    // if (this.availablePagesSubscription) {
    //   this.availablePagesSubscription.unsubscribe();
    // }

    // if (this.totalPagesSubscription) {
    //   this.totalPagesSubscription.unsubscribe();
    // }

    this.destroy$.next();
    this.destroy$.complete();
  }

  unclaimTask(taskId: string): Observable<any> {
    return this.invoiceService.unclaimTaskFromAPI(taskId);
  }

  onViewerChanged($event: MatRadioChange) {
    this.captureService.canvasChosen.next($event.value);
  }

  onPageChanged($event: MatButtonToggleChange) {
    this.currentPage = $event.value;
    this.captureService.pageChanged.next($event.value);
  }

  cleanDateText(text: string): string {
    if (!text) { return ''; }

    let cleanedText = text.trim();

    cleanedText = cleanedText.replace(/\s+/g, ' ');

    cleanedText = cleanedText.replace(/[\/\-.,]/g, ' ');

    cleanedText = cleanedText.replace(/(\d)([A-Za-z])/g, '$1 $2');

    cleanedText = cleanedText.replace(/([A-Za-z])(\d)/g, '$1 $2');

    cleanedText = cleanedText.replace(/\s+/g, ' ').trim();

    return cleanedText;
  }

  private handleResponseTask(data: any) {
    this.legalId = data.processInstanceVariables.invoice_customerParty_legalId;
    this.workspaceId = data.processInstanceVariables.workspace_id;

    this.getTenantCurrencyOptions();

    this.invoice.setFieldWithBrainPrediction(data.processInstanceVariables);
    this.invoiceId =
      data.processInstanceVariables.invoice_invoiceStore_invoiceId;

    this.modelId =
      data.processInstanceVariables.modelId ? data.processInstanceVariables.modelId : 'UNAVAILABLE';

    this.subjectSelectionSubscription =
      this.captureService.subjectSelection.subscribe((item) => {
        let result: captureValue;
        const field = this.fields.get(this.currentIndex);
        if (this.isFormItemDate(field)) {
          const cleanedText = this.cleanDateText(item.text);
          const parsed = dateParser(cleanedText);
          if (parsed) {
            result = parsed;
          }
          // if the field is 'issueDate', verify that the date is greater Than Today
          if (field.field === 'issueDate' && result < new Date()) {
            this.dateInFuture = true;
          } else {
            this.dateInFuture = false;
          }
        } else if (this.isFormItemNumber(field)) {
          const cleanedAmount = amountsCleaner(item.text);
          const parsedAmount = amountsParser(cleanedAmount);

          if (!isNaN(parsedAmount)) {
            result = parsedAmount;
          } else {
            result = '';
          }
        } else if (this.isFormItemReference(field)) {
          result = referenceCleaner(item.text);
        } else if (this.isFormItemIce(field)) {
          result = iceCleaner(item.text);
          if (field.field === 'recipientPartyLegalId') {
            if (result !== this.legalId) {
              this.iceRecipient.control.setErrors({error: ''});
            } else {
              this.iceRecipient.control.setErrors(null);
            }
          } else {
            this.iceSender.control.setValue(result, {emitEvent: true});
          }
        } else {
          result = item.text;
        }

        if (this.currentIndex === 11) {
          const matchedCurrency = this.currencies.find(currency =>
            currency.id === result || currency.name === result
          );

          if (matchedCurrency) {
            this.invoice.setFieldAtIndex(this.currentIndex, matchedCurrency);
          }
        } else {
          this.invoice.setFieldAtIndex(this.currentIndex, result);
        }

        if (this.currentIndex < this.fields.size - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0;
        }
        this.captureService.changeInput(
          this.fields.get(this.currentIndex).text
        );

        let nextElement = null;
        if (this.currentIndex !== 11) {
          this.form.nativeElement.querySelector(
            'input[name="' + this.fields.get(this.currentIndex).field + '"]'
          );
        } else {
          nextElement = this.form.nativeElement.querySelector(
            'mat-select[name="' +
            this.fields.get(this.currentIndex).field +
            '"]'
          );
        }

        if (nextElement !== undefined && nextElement !== null) {
          nextElement.focus();
        }
      });

    this.iceRecipient.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value !== this.legalId) {
          this.iceRecipient.control.setErrors({error: ''});
        } else {
          this.iceRecipient.control.setErrors(null);
        }
      });

    this.iceSender.valueChanges
      .pipe(takeUntil(this.destroy$), debounceTime(700))
      .subscribe((value) => {
        this.invoiceService.getSupplierCount(value).subscribe((result) => {
          if (result === 0) {
            this.iceSender.control.setErrors({error: ''});
          } else {
            this.iceSender.control.setErrors(null);
          }
        });
      });

    this.iceRecipient.control.markAsTouched();

    this.iceSender.control.markAsTouched();
  }

  private getTenantCurrencyOptions() {
    if (this.workspaceId !== undefined) {
      this.workspaceService.getWorkspace(this.workspaceId).subscribe((wp) => {
        this.currencyService
          .getCurrenciesByTenant(wp.tenantId)
          .subscribe(
            (response) => (this.currencies = this.toFormOptions(response.body))
          );
      });
    }
  }

  private toFormOptions(currencies: ICurrency[]): IOption[] {
    return currencies.map((currency): IOption => {
      return {
        id: currency.code + '',
        name: currency.code,
      };
    });
  }

  navigateFormElements(event: KeyboardEvent, direction: 'next' | 'previous') {
    event.preventDefault();

    const maxIndex = 11;
    let newIndex;

    if (direction === 'next') {
      newIndex = (this.currentIndex + 1) <= maxIndex ? (this.currentIndex + 1) : 0;
    } else {
      newIndex = (this.currentIndex - 1) >= 0 ? (this.currentIndex - 1) : maxIndex;
    }

    this.currentIndex = newIndex;

    this.captureService.changeInput(this.fields.get(this.currentIndex).text);

    // Find the element with the new index
    const inputElements = this.formInputs.toArray();

    if (newIndex === 11) {
      // if (this.currencySelect) {
      //   this.currencySelect.open = () => {};

      //   // Focus the element
      //   this.currencySelect._elementRef.nativeElement.focus();
      // }

      const currentElement = this.form.nativeElement.querySelector(
        'mat-select[name="' +
        this.fields.get(newIndex).field +
        '"]'
      );
      currentElement.focus();

      if (direction === 'next') {
        currentElement.addEventListener('keydown', function preventEnterKeyFromAdvancing(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();

            currentElement.removeEventListener('keydown', preventEnterKeyFromAdvancing);
          }
        }, { once: true });
      }
    }
    else if (inputElements && inputElements[newIndex] && newIndex !== 11) {
      inputElements[newIndex].nativeElement.focus();
    }
  }

  focusCurrentInput() {
    const inputElements = this.formInputs.toArray();
    if (this.currentIndex >= 0 && this.currentIndex < inputElements.length) {
      inputElements[this.currentIndex].nativeElement.focus();
    }
  }

  onDatePickerClosed() {
    this.currentIndex = 5;
    this.focusCurrentInput();
  }
}

export class Field {
  constructor(
    public field: string,
    public text: string,
    public type: FormItemType,
    public value: any
  ) {
  }
}

enum FormItemType {
  Text = 'text',
  Date = 'date',
  Number = 'number',
  Reference = 'reference',
  Ice = 'ice',
}

type captureValue = string | number | Date;
